// extracted by mini-css-extract-plugin
module.exports = {"worningStyle":"EmployeeDeallocationPopup_worningStyle__1KRfK","iconStyle":"EmployeeDeallocationPopup_iconStyle__3FiFY"};